// @flow
import * as React from 'react';
import classNames from 'classnames';
import Collapse from 'reactstrap/lib/Collapse';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'react-fast-compare';
import styles from './Facet.module.scss';

type Props = {
    children: React.Node,
    className: string,
    closeFacet: boolean,
    header?: React.Node,
    hideExpandCollapse: boolean,
    hideTitle: boolean,
    title: string,
};

type State = {
    close: boolean,
};

export default class Facet extends React.Component<Props, State> {
    static defaultProps = {
        className: '',
        closeFacet: false,
        hideExpandCollapse: false,
        hideTitle: false,
    };

    state = { close: this.props.closeFacet };

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentDidUpdate(prevProps: Props) {
        if (this.props.closeFacet !== prevProps.closeFacet) {
            this.setState({ close: this.props.closeFacet });
        }
    }

    handleClick = () => this.setState({ close: !this.state.close });

    render() {
        const { className, hideExpandCollapse, hideTitle, header, title } = this.props;
        const classes = classNames(styles['facet'], className);

        return (
            <div className={classes}>
                {!hideTitle && !hideExpandCollapse && (
                    <div className={styles.title} onClick={this.handleClick}>
                        {!hideTitle && title}
                        {!hideExpandCollapse && (
                            <FontAwesomeIcon
                                icon={this.state.close ? faCaretDown : faCaretUp}
                                className={styles.expander}
                            />
                        )}
                    </div>
                )}
                <Collapse isOpen={!this.state.close}>
                    <div className={styles.panel}>
                        {header}
                        {this.props.children}
                    </div>
                </Collapse>
            </div>
        );
    }
}
